var Tour = {};

// Версия плеера
Tour.version = [2, 26, 1];
